import { NoticeWarning } from '@fs/zion-icon/dist/cjs/icons'
import { IconButton, QuickGlanceOverlay, ResponsiveTableRow, Separator, useOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../../common/DmcResponsiveTable'
import DmcCopyToClipboardTooltip from '../../../../util/DmcCopyToClipboardTooltip'
import { getIdElement } from '../../../../util/StringUtil'

export default function RepeatedOwsIdsButton({ owsIdsAndRoles }) {
  const { t } = useTranslation()
  const overlay = useOverlay()

  return (
    <>
      <IconButton Icon={NoticeWarning} color="yellow" onClick={overlay.handleClick} data-testid="repeatedOwsIds" />
      <QuickGlanceOverlay {...overlay} title={t('repeatedOwsIds.title', 'Repeated OWS IDs')} placement="top">
        <DmcResponsiveTable
          totalColumnCount={2}
          atSizeColumns={{
            default: {
              labels: ['OWS ID', 'Roles'],
            },
          }}
        >
          {Object.entries(owsIdsAndRoles).map(([owsId, roles]) => (
            <ResponsiveTableRow
              key={owsId}
              column1={
                <DmcCopyToClipboardTooltip
                  value={getIdElement(owsId)}
                  path={`/temple/ows/${getIdElement(owsId)}/summary`}
                  newTab
                />
              }
              column2={roles}
            />
          ))}
        </DmcResponsiveTable>
        <Separator />
      </QuickGlanceOverlay>
    </>
  )
}
